import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import Root from './Root';

const containerInjector = (store) => {
  const AppProvider = () => (
    <AppContainer>
      <Root store={store}/>
    </AppContainer>
  );

  ReactDOM.render(
    <AppProvider/>,
    document.getElementById('app')
  );

  if (module.hot) {
    module.hot.accept('./Root.jsx', () => {
      /* eslint-disable global-require */
      const RootContainer = require('./Root').default;
      /* eslint-enable global-require */
      ReactDOM.render(
        <AppContainer>
          <RootContainer store={store}/>
        </AppContainer>,
        document.getElementById('app')
      );
    });
  }
};
export default containerInjector;




// WEBPACK FOOTER //
// ./book/src/commons/components/containerInjector.jsx